module.exports = __webpack_public_path__ + "img/1267375227.d96cc8c3.jpg";